import React from "react";
import { WZ_GLYPHS } from "../../core/constants";
import { zodiacGlyphPosition } from "../visual/zodiacRing";

export default function NatalChartDeco({ acc, size = 280 }) {
  const r = size * 0.38;
  const inner = size * 0.55;
  const core = size * 0.2;

  return (
    <div
      className="landing-seo__chart-deco"
      aria-hidden="true"
      style={{
        position: "relative",
        width: size,
        height: size,
        margin: "0 auto",
        flexShrink: 0,
      }}
    >
      <div
        className="landing-seo__chart-deco-ring"
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          border: `1px dashed ${acc.primary}33`,
          animation: "spin-slow 60s linear infinite",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: inner,
          height: inner,
          marginLeft: -inner / 2,
          marginTop: -inner / 2,
          borderRadius: "50%",
          border: `1px solid ${acc.secondary}22`,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: core,
          height: core,
          marginLeft: -core / 2,
          marginTop: -core / 2,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${acc.secondary}99, ${acc.primary}44)`,
          boxShadow: `0 0 24px ${acc.primary}66`,
        }}
      />
      {WZ_GLYPHS.map((glyph, i) => (
        <span
          key={glyph}
          style={{
            position: "absolute",
            ...zodiacGlyphPosition(i, r),
            fontSize: Math.max(14, size * 0.065),
            opacity: 0.35,
            color: acc.primary,
          }}
        >
          {glyph}
        </span>
      ))}
    </div>
  );
}
